export const MINIMUM_LOCATION_COUNT_FOR_MEAN_CHARTS = 10;
